<template>
  <div class="phrase-overlay" :style="dialog_on ? 'z-index:300010' : 'z-index:-30000; opacity:0'">
    <transition name="fade">
      <div class="create-phrase-wrap" v-if="dialog_on">
        <div class="newmessage-title">
          <span>
            {{ notification.title }}
          </span>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="closeDialog()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="list-create-box challenge">
          <div style="margin:0 10px; line-height: 1.8">
            <pre>{{ notification.detail }}</pre>
          </div>
        </div>

        <div class="list-create-footer">
          <el-button type="primary" @click="closeDialog()">閉じる</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const readNotificationAPI = root + "/api/dashboard/read_notification";

export default {
  name: "notificationDialog",
  props: ["notification", "dialog_on"],
  data() {
    return {};
  },
  computed: {
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog_on", false);
    },
    readNotification() {
      var params = new URLSearchParams();
      params.append("user_token", this.user_token);
      params.append("notification_id", this.notification.no);
      this.axios
        .post(readNotificationAPI, params)
        .then(() => {
        })
        .catch(() => {});
    },
  },
  watch: {
    dialog_on(){
      if (this.dialog_on==true) {
        this.readNotification()
      }
    }
  }
};
</script>

<style></style>
